// extracted by mini-css-extract-plugin
export var rightPanelOpenOld = "_9i-0";